import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, RouteConfigLoadStart,
  Router
} from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd';
import { ALAIN_I18N_TOKEN, MenuService, ScrollService, SettingsService } from '@delon/theme';

import { environment } from '@env/environment';
import { SettingDrawerComponent } from './setting-drawer/setting-drawer.component';
import { Subscription } from 'rxjs';
import { updateHostClass } from '@delon/util';
import { DOCUMENT } from '@angular/common';
import { StartupService } from '@core/startup/startup.service';
import { PersonService } from '../../routes/jy-org/person/service/person.service';
import { I18NService } from '@core/i18n/i18n.service';
import {CommonsService} from "@core/service/commons.service";

@Component({
  selector: 'layout-default',
  templateUrl: './default.component.html',
  preserveWhitespaces: false,
  host: {
    '[class.alain-default]': 'true',
  },
})
export class LayoutDefaultComponent
implements OnInit, AfterViewInit, OnDestroy {
  private notify$: Subscription;
  isFetching = false;
  @ViewChild('settingHost', { read: ViewContainerRef })
  settingHost: ViewContainerRef;

  constructor(
    router: Router,
    scroll: ScrollService,
    _message: NzMessageService,
    private resolver: ComponentFactoryResolver,
    public menuSrvice: MenuService,
    public settings: SettingsService,
    private startupService:StartupService,
    private el: ElementRef,
    private renderer: Renderer2,
    private personService:PersonService,
    @Inject(DOCUMENT) private doc: any,
    @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
    private activatedRoute:ActivatedRoute,
    private commonsService:CommonsService
  ) {
    // scroll to top in change page
    router.events.subscribe(evt => {
      if (!this.isFetching && evt instanceof RouteConfigLoadStart) {
        this.isFetching = true;
      }
      if (evt instanceof NavigationError || evt instanceof NavigationCancel) {
        this.isFetching = false;
        if (evt instanceof NavigationError) {
          _message.error(`无法加载${evt.url}路由`, { nzDuration: 1000 * 3 });
        }
        return;
      }
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      setTimeout(() => {
        /**
         * oa内嵌网页的页面不要执行滚动,否则会把oa头部覆盖掉
         * */
        if(!this.startupService.oaWindowBol){
          scroll.scrollToTop();
        }
        this.isFetching = false;
      }, 100);
    });
  }

  private setClass() {
    const { el, renderer, settings } = this;
    const layout = settings.layout;
    updateHostClass(
      el.nativeElement,
      renderer,
      {
        ['alain-default']: true,
        [`alain-default__fixed`]: layout.fixed,
        [`alain-default__boxed`]: layout.boxed,
        [`alain-default__collapsed`]: layout.collapsed,
      },
      true
    );

    this.doc.body.classList[layout.colorWeak ? 'add' : 'remove']('color-weak');
  }

  ngAfterViewInit(): void {
    this.startupService.loadUserData();
    this.personService.getAndSetCurrentPerson();
    // Setting componet for only developer
    if (!environment.production) {
      setTimeout(() => {
        const settingFactory = this.resolver.resolveComponentFactory(
          SettingDrawerComponent
        );
        this.settingHost.createComponent(settingFactory);
      }, 22);
    }
    //在此订阅语言修改事件，触发菜单重新拉取
    this.i18n.change.subscribe(() => {
      this.startupService.loadUserData();
    });
  }

  public oaBol:boolean = false;
  ngOnInit() {
    this.notify$ = this.settings.notify.subscribe(() => this.setClass());
    this.activatedRoute.queryParams.subscribe((value) => {
      if(value.oaNew){
        this.oaBol = true;
      }
    });
    this.setClass();
    this.commonsService.getUnitConver();
  }

  ngOnDestroy() {
    this.notify$.unsubscribe();
  }
}
